// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--X4z2p","sidebar__light-inner":"Sidebar-module--sidebar__light-inner--1_59e","sidebar__dark-inner":"Sidebar-module--sidebar__dark-inner--BtP1E"};